{
  "v2.espaces.accorder_droit_isole": "Grant an isolated permission",
  "v2.espaces.ajouter.ajoute": "Member added as a reader.",
  "v2.espaces.ajouter.ajouter": "Add",
  "v2.espaces.ajouter.aucun": "Nobody in the organisation directory matches.",
  "v2.espaces.ajouter.choisir": "Choose a person.",
  "v2.espaces.ajouter.deja_membre": "{{nom}} (already a member)",
  "v2.espaces.ajouter.echec": "The member could not be added.",
  "v2.espaces.ajouter.lecteur_programme": "The person joins as Programme reader; another profile is given afterwards through “Manage profiles”.",
  "v2.espaces.ajouter.lecteur_projet": "The person joins as Reader; another profile is given afterwards through “Manage profiles”, with the permission to assign.",
  "v2.espaces.ajouter.quelqu_un_d_autre": "Already a member: choose someone else.",
  "v2.espaces.ajouter.recherche": "Search the organisation directory",
  "v2.espaces.ajouter.resultats": "People found",
  "v2.espaces.ajouter.titre_programme": "Add a member to the programme",
  "v2.espaces.ajouter.titre_projet": "Add an organisation member to the project",
  "v2.espaces.ajouter_membre": "Add a member",
  "v2.espaces.annuler": "Cancel",
  "v2.espaces.code.ACCESS_REQUEST_NOT_FOUND": "This request no longer exists.",
  "v2.espaces.code.ACCESS_REQUEST_NOT_PENDING": "This request has already been decided by someone else.",
  "v2.espaces.code.ACCESS_REQUEST_SELF_DECISION": "You cannot decide your own request.",
  "v2.espaces.code.ALREADY_MEMBER": "This person is already a member.",
  "v2.espaces.code.COMPTE_DESACTIVE": "This account is deactivated.",
  "v2.espaces.code.CONFLIT_CONCURRENT": "This member was changed meanwhile: their record is reloaded, try again.",
  "v2.espaces.code.CORPS_HISTORIQUE_RETIRE": "Request in a former format, refused.",
  "v2.espaces.code.DROIT_HORS_NIVEAU": "This permission does not belong to this level.",
  "v2.espaces.code.DROIT_ISOLE_INTROUVABLE": "This isolated permission no longer exists.",
  "v2.espaces.code.DROIT_NON_TENU": "You do not hold the required permission.",
  "v2.espaces.code.DROIT_PERSONNEL_NON_ACCORDABLE": "This permission is personal: it cannot be granted.",
  "v2.espaces.code.DROIT_RESERVE_AU_PROPRIETAIRE": "This permission is reserved to the owner: it cannot be granted in isolation.",
  "v2.espaces.code.ECHEANCE_PASSEE": "The end date must be in the future.",
  "v2.espaces.code.INVITATION_EMAIL_DOMAIN_NOT_ALLOWED": "This address domain is refused by the organisation policy.",
  "v2.espaces.code.LAST_OWNER": "The last owner cannot be removed: transfer ownership first.",
  "v2.espaces.code.MOTIF_TROP_COURT": "The reason needs at least 15 characters.",
  "v2.espaces.code.NOT_FOUND": "Not found: the person or project no longer exists.",
  "v2.espaces.code.PERSONNE_NON_MEMBRE": "This person is not a member: add them first.",
  "v2.espaces.code.PROFIL_INCONNU": "This profile is not published in the organisation.",
  "v2.espaces.code.PROFIL_NIVEAU_INCOMPATIBLE": "This profile does not apply at this level.",
  "v2.espaces.code.PROGRAM_LAST_OWNER": "The last programme owner cannot be removed: transfer ownership first.",
  "v2.espaces.code.PROGRAM_MEMBER_EXISTS": "This person is already a member.",
  "v2.espaces.code.PROGRAM_MEMBER_NOT_FOUND": "This person is not (or no longer) a programme member.",
  "v2.espaces.code.PROGRAM_MEMBER_UNKNOWN_USER": "This person is unknown to the organisation.",
  "v2.espaces.code.RESOURCE_UNAVAILABLE": "Not found or unavailable.",
  "v2.espaces.code.RETRAIT_DE_SOI": "You cannot remove yourself from a project.",
  "v2.espaces.code.VALIDATION_ERROR": "Invalid input.",
  "v2.espaces.confirmer_retrait_droit_isole": "Confirm removal of the isolated permission",
  "v2.espaces.demande.approved": "granted",
  "v2.espaces.demande.cancelled": "cancelled",
  "v2.espaces.demande.pending": "pending",
  "v2.espaces.demande.rejected": "refused",
  "v2.espaces.depuis": "Since {{date}}",
  "v2.espaces.deux_caracteres": "At least two characters.",
  "v2.espaces.droit_isole.accorde": "Isolated permission granted and written to the log.",
  "v2.espaces.droit_isole.accorder": "Grant",
  "v2.espaces.droit_isole.aucun_prerequis": "No reading prerequisite.",
  "v2.espaces.droit_isole.choisir": "Choose a permission",
  "v2.espaces.droit_isole.date_de_fin": "End date (optional)",
  "v2.espaces.droit_isole.date_passee": "The end date must be in the future.",
  "v2.espaces.droit_isole.deja_tenu": "Already held through a profile: this isolated permission would add nothing.",
  "v2.espaces.droit_isole.droit": "Permission",
  "v2.espaces.droit_isole.droit_requis": "Choose a permission.",
  "v2.espaces.droit_isole.echec": "The isolated permission was not granted.",
  "v2.espaces.droit_isole.motif": "Reason",
  "v2.espaces.droit_isole.motif_aide": "At least 15 characters.",
  "v2.espaces.droit_isole.motif_court": "The reason needs at least 15 characters.",
  "v2.espaces.droit_isole.pour": "For: {{nom}}",
  "v2.espaces.droit_isole.prerequis": "Granted with it, so that it can be used: {{droits}}",
  "v2.espaces.droit_isole.prolonger": "Already granted: granting again extends its end date.",
  "v2.espaces.droit_isole.titre_programme": "Grant an isolated permission on the programme",
  "v2.espaces.droit_isole.titre_projet": "Grant an isolated permission on the project",
  "v2.espaces.droit_isole_retire": "Isolated permission removed; history is kept.",
  "v2.espaces.droit_isole_retrait_echec": "The isolated permission was not removed.",
  "v2.espaces.droits_effectifs.aucun": "No change of permissions.",
  "v2.espaces.droits_effectifs.aucun_droit": "None",
  "v2.espaces.droits_effectifs.descend": "In descendant projects: {{n}}",
  "v2.espaces.droits_effectifs.erreur": "The permission simulation did not respond.",
  "v2.espaces.droits_effectifs.gagnes": "Permissions gained",
  "v2.espaces.droits_effectifs.perdus": "Permissions lost",
  "v2.espaces.droits_effectifs.titre": "Effective permissions",
  "v2.espaces.ecart_signale": "Deviation flagged",
  "v2.espaces.etat.chargement": "Loading {{quoi}}…",
  "v2.espaces.etat.en_cours": "In progress…",
  "v2.espaces.etat.erreur": "{{quoi}}: could not be read.",
  "v2.espaces.etat.reessayer": "Retry",
  "v2.espaces.etat.refus": "{{quoi}}: access denied.",
  "v2.espaces.etat_droit.en_vigueur": "In force",
  "v2.espaces.etat_droit.expire": "Expired",
  "v2.espaces.etat_droit.expire_bientot": "Expires soon",
  "v2.espaces.expire_le": "expires on {{date}}",
  "v2.espaces.fermer": "Close",
  "v2.espaces.invitation.accepted": "Accepted",
  "v2.espaces.invitation.declinee": "Declined",
  "v2.espaces.invitation.expired": "Expired",
  "v2.espaces.invitation.pending": "Pending",
  "v2.espaces.invitation.revoked": "Revoked",
  "v2.espaces.inviter.copie": "Link copied.",
  "v2.espaces.inviter.copier": "Copy the link",
  "v2.espaces.inviter.echec": "The invitation was not sent.",
  "v2.espaces.inviter.email": "Email address",
  "v2.espaces.inviter.email_invalide": "Invalid email address.",
  "v2.espaces.inviter.envoyee": "Invitation sent by email: the person will join as Reader.",
  "v2.espaces.inviter.inviter": "Invite",
  "v2.espaces.inviter.lecteur": "The person joins as Reader; another profile is given afterwards through “Manage profiles”.",
  "v2.espaces.inviter.lien": "Single-use link",
  "v2.espaces.inviter.lien_masque": "The single-use link appears after sending.",
  "v2.espaces.inviter.non_parti": "The email was not sent: copy the single-use link and pass it on.",
  "v2.espaces.inviter.titre": "Invite a person to the project",
  "v2.espaces.jusqu_au": "until {{date}}",
  "v2.espaces.origine.organisation": "from the organisation",
  "v2.espaces.origine.programme": "from the programme",
  "v2.espaces.origine.projet": "from the project",
  "v2.espaces.origine_droit.attribution_historique": "carried-over grant without reason",
  "v2.espaces.origine_droit.droit_isole": "granted by name",
  "v2.espaces.personne_absente": "No person selected: go back to the member list to choose one.",
  "v2.espaces.profil_herite": "{{profil}} (inherited {{origine}})",
  "v2.espaces.profils.ajouter": "Profile to add",
  "v2.espaces.profils.choisir": "Choose a profile",
  "v2.espaces.profils.dernier_programme": "Without a programme profile, the person remains a member as Programme reader.",
  "v2.espaces.profils.dernier_projet": "Without a project profile, the person remains a member as Reader.",
  "v2.espaces.profils.echec": "The profiles were not saved.",
  "v2.espaces.profils.enregistrer": "Save profiles",
  "v2.espaces.profils.enregistres": "Profiles saved.",
  "v2.espaces.profils.herite_non_modifiable": "Can only be changed at its own level.",
  "v2.espaces.profils.introuvable": "This person is not (or no longer) a member of the project.",
  "v2.espaces.profils.liste": "Profiles",
  "v2.espaces.profils.membre_vise": "Member: {{nom}}",
  "v2.espaces.profils.proprietaire": "Owner: keeps the reserved permissions whatever the profile.",
  "v2.espaces.profils.retirer": "Remove the profile {{profil}}",
  "v2.espaces.profils.rien_a_changer": "Nothing to change.",
  "v2.espaces.profils.titre": "Manage the profiles of a project member",
  "v2.espaces.programme_membres.aucun_choisi": "Choose a member to see their profiles and permissions.",
  "v2.espaces.programme_membres.confirmer_retrait": "Confirm removal from the programme",
  "v2.espaces.programme_membres.descend": "Applies to {{n}} projects",
  "v2.espaces.programme_membres.droits_isoles": "Programme isolated permissions",
  "v2.espaces.programme_membres.droits_isoles_vide": "No isolated permission on this programme.",
  "v2.espaces.programme_membres.liste": "Members",
  "v2.espaces.programme_membres.retire": "Member removed from the programme; their programme profiles and isolated permissions are removed.",
  "v2.espaces.programme_membres.retirer": "Remove from the programme",
  "v2.espaces.programme_membres.retrait_echec": "The removal did not succeed.",
  "v2.espaces.programme_membres.retrait_proprietaire": "The owner cannot be removed: transfer programme ownership first.",
  "v2.espaces.programme_membres.titre": "Programme members",
  "v2.espaces.programme_membres.vide": "No member in this programme.",
  "v2.espaces.projet_membres.acces": "Access requests",
  "v2.espaces.projet_membres.acces_accorde": "Access granted: the person joins as Reader.",
  "v2.espaces.projet_membres.acces_aucune_attente": "No pending access request.",
  "v2.espaces.projet_membres.acces_refuse": "Access refused.",
  "v2.espaces.projet_membres.acces_vide": "No access request.",
  "v2.espaces.projet_membres.accorder_acces": "Grant access to {{nom}}",
  "v2.espaces.projet_membres.accorder_court": "Grant",
  "v2.espaces.projet_membres.admin_descendante": "Organisation administration (inherited)",
  "v2.espaces.projet_membres.confirmer_revocation": "Confirm revocation",
  "v2.espaces.projet_membres.creer_equipe": "Create a team",
  "v2.espaces.projet_membres.decidees": "Past decisions",
  "v2.espaces.projet_membres.decision_echec": "The decision was not recorded.",
  "v2.espaces.projet_membres.designation": "{{role}}: {{personne}} since {{date}}",
  "v2.espaces.projet_membres.designation_aucune": "Choose a designation.",
  "v2.espaces.projet_membres.designation_choisie": "Selected designation",
  "v2.espaces.projet_membres.designation_manquante": "Required by the model, missing: {{role}}",
  "v2.espaces.projet_membres.designations": "Designations",
  "v2.espaces.projet_membres.designations_vide": "No designation.",
  "v2.espaces.projet_membres.designer": "Designate",
  "v2.espaces.projet_membres.droit_isole_tenu": "Isolated permission: {{droit}}, {{echeance}}",
  "v2.espaces.projet_membres.droits_isoles": "Project isolated permissions",
  "v2.espaces.projet_membres.droits_isoles_vide": "No isolated permission on this project.",
  "v2.espaces.projet_membres.effacer_recherche": "Clear the search",
  "v2.espaces.projet_membres.equipes": "Teams",
  "v2.espaces.projet_membres.equipes_vide": "No team.",
  "v2.espaces.projet_membres.etat_actuel": "Current state, not a history.",
  "v2.espaces.projet_membres.gerer_profils": "Manage profiles",
  "v2.espaces.projet_membres.invitations": "Invitations",
  "v2.espaces.projet_membres.invitations_vide": "No invitation.",
  "v2.espaces.projet_membres.inviter": "Invite a person",
  "v2.espaces.projet_membres.liste": "Members",
  "v2.espaces.projet_membres.membres_comptes": "{{n}} members",
  "v2.espaces.projet_membres.motif_refus": "Reason for refusal (optional)",
  "v2.espaces.projet_membres.onglet.activite": "Activity",
  "v2.espaces.projet_membres.onglet.apercu": "Overview",
  "v2.espaces.projet_membres.onglet.indicateurs": "Indicators",
  "v2.espaces.projet_membres.onglet.membres": "Members",
  "v2.espaces.projet_membres.onglet.methode": "Method and process",
  "v2.espaces.projet_membres.onglets": "Project tabs",
  "v2.espaces.projet_membres.ordre": "Order",
  "v2.espaces.projet_membres.ordre_croissant": "Ascending",
  "v2.espaces.projet_membres.ordre_decroissant": "Descending",
  "v2.espaces.projet_membres.origine": "Origin of authorisations",
  "v2.espaces.projet_membres.origine_aucun": "Choose a member to see where their authorisations come from.",
  "v2.espaces.projet_membres.origine_vide": "No authorisation on this project.",
  "v2.espaces.projet_membres.recette": "Run an acceptance test",
  "v2.espaces.projet_membres.recette_accordee": "Acceptance: granted",
  "v2.espaces.projet_membres.recette_confirmer": "Confirm the acceptance permission",
  "v2.espaces.projet_membres.recette_non_accordee": "Acceptance: not granted",
  "v2.espaces.projet_membres.recette_retirer": "Confirm removal of the acceptance permission",
  "v2.espaces.projet_membres.recherche": "Search a member",
  "v2.espaces.projet_membres.refuser_acces": "Refuse access to {{nom}}",
  "v2.espaces.projet_membres.refuser_court": "Refuse",
  "v2.espaces.projet_membres.restreint": "Restricted by: {{profils}}",
  "v2.espaces.projet_membres.retirer": "Remove from the project",
  "v2.espaces.projet_membres.retirer_droit_isole": "Remove the isolated permission {{droit}} from {{personne}}",
  "v2.espaces.projet_membres.retrait_proprietaire": "The last owner cannot be removed: transfer project ownership first.",
  "v2.espaces.projet_membres.retrait_soi": "This is you: you cannot remove yourself from a project.",
  "v2.espaces.projet_membres.revocation_echec": "The revocation did not succeed.",
  "v2.espaces.projet_membres.revoquee": "Invitation revoked.",
  "v2.espaces.projet_membres.revoquer": "Revoke the invitation of {{email}}",
  "v2.espaces.projet_membres.revoquer_court": "Revoke",
  "v2.espaces.projet_membres.titre": "Project members",
  "v2.espaces.projet_membres.tri.depuis": "Joining date",
  "v2.espaces.projet_membres.tri.profil": "Profile",
  "v2.espaces.projet_membres.tri.utilisateur": "Person",
  "v2.espaces.projet_membres.trier_par": "Sort by",
  "v2.espaces.projet_membres.vide": "No member in this project.",
  "v2.espaces.projet_membres.voir_equipe": "View the team {{equipe}}",
  "v2.espaces.proprietaire": "Owner",
  "v2.espaces.retirer.attestation": "I have told the person and reassigned their work.",
  "v2.espaces.retirer.attestation_requise": "Tick the attestation to remove.",
  "v2.espaces.retirer.aucun": "none",
  "v2.espaces.retirer.designations": "Designations to take over: {{liste}}",
  "v2.espaces.retirer.echec": "The removal did not succeed.",
  "v2.espaces.retirer.effets": "Effects of the removal",
  "v2.espaces.retirer.equipes": "Teams left: {{liste}}",
  "v2.espaces.retirer.personne": "Person to remove: {{nom}}",
  "v2.espaces.retirer.retire": "Person removed from the project.",
  "v2.espaces.retirer.titre": "Remove a person from the project — confirmation",
  "v2.espaces.retirer.travail": "Assigned work to reassign: {{n}}",
  "v2.espaces.retirer_court": "Remove",
  "v2.espaces.retirer_droit_isole": "Remove the isolated permission {{droit}}",
  "v2.espaces.sans_echeance": "no end date",
  "v2.espaces.sans_programme": "No programme chosen: choose a programme to see its members.",
  "v2.espaces.sans_projet": "No project chosen: choose a project to see its members.",
  "v2.espaces.vague_ulterieure": "“{{ecran}}” is not built yet: it comes with wave {{vague}}."
}
